import { useState, useEffect } from "react";
import { getAuthUser, clearStorage, getAuthToken } from "../../helpers";
import { BellIcon, UserIcon } from "../../assets/svg";
import { useLocation, Link, useNavigate } from "react-router";
import { useUserStore } from "../../zustand/auth";

const routes = [
  {
    name: "Home",
    path: "/",
  },
  {
    name: "Courses",
    path: "/courses",
  },
  {
    name: "MCQ",
    path: "/mcq",
  },
  {
    name: "Users",
    path: "/users",
  },
  {
    name: "Upload",
    path: "/uploads",
  },
  {
    name: "Survey",
    path: "/survey",
  },
  // {
  //   name: "Announcement",
  //   path: "/announcement",
  // },

  // {
  //   name: "Settings",
  //   path: "/settings",
  // },
];


export const Navbar = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { userData, updateUserData } = useUserStore();
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Sync userData from localStorage if store is empty but token exists
  if ((!userData || Object.keys(userData).length === 0) && getAuthToken()) {
    const user = getAuthUser();
    if (user && Object.keys(user).length > 0) updateUserData(user);
  }

  const currentUser = (userData && Object.keys(userData).length > 0) ? userData : getAuthUser();
  const hasUser = currentUser && Object.keys(currentUser).length > 0;

  return (
    <header
      className={`sticky top-0 z-50 bg-white transition-shadow duration-200 ${scrolled ? "shadow-[0_1px_12px_rgba(0,0,0,.08)]" : "border-b border-slate-200"
        }`}
    >
      {/* --- Top Tier: Logo & User Actions --- */}
      <div className="flex items-center justify-between px-6 md:px-11 h-[68px] max-w-[2000px] mx-auto">
        <Link to="/" className="font-display font-bold text-primary-900 text-base md:text-xl whitespace-nowrap tracking-tight hover:opacity-80 transition-opacity">
          BudgIT Academy
        </Link>

        <div className="flex items-center gap-6">
          <button className="text-slate-500 hover:text-primary-900 transition-colors">
            <BellIcon />
          </button>

          {hasUser ? (
            <div className="relative">
              <button
                onClick={() => setShowUserDropdown(!showUserDropdown)}
                className="w-9 h-9 rounded-full bg-primary-100 border-2 border-primary-200 flex items-center justify-center hover:border-primary-400 transition-colors"
              >
                <UserIcon />
              </button>

              {showUserDropdown && (
                <div className="absolute top-11 right-0 w-56 flex-col rounded-2xl shadow-card bg-white border border-slate-100 overflow-hidden z-50 flex animate-in fade-in zoom-in duration-200">
                  <div className="px-4 py-3 border-b border-slate-100 bg-slate-50">
                    <p className="text-sm font-semibold text-slate-800">
                      {currentUser?.first_name} {currentUser?.last_name}
                    </p>
                    <p className="text-xs text-slate-500 capitalize">
                      {currentUser?.role?.name}
                    </p>
                  </div>
                  <button
                    onClick={() => {
                      clearStorage();
                    }}
                    className="px-4 py-3 text-sm text-left text-danger font-medium hover:bg-red-50 transition-colors"
                  >
                    Sign out
                  </button>
                </div>
              )}
            </div>
          ) : (
            <button
              onClick={() => navigate("/login")}
              className="px-5 py-2.5 rounded-xl border-2 border-primary-900 text-primary-900 text-sm font-semibold hover:bg-primary-900 hover:text-white transition-all duration-200"
            >
              Login
            </button>
          )}
        </div>
      </div>

      {/* --- Bottom Tier: Navigation Tabs --- */}
      {getAuthToken() && (
        <div className="border-t border-slate-100 bg-slate-50">
          <div className="flex items-center gap-1 px-6 md:px-11 max-w-[2000px] mx-auto overflow-x-auto no-scrollbar whitespace-nowrap">
            {routes.map((r, i) => {
              const isHidden = (r.name === "Users" && currentUser?.role?.name !== "super-admin") ||
                (r.name !== "Users" && r.name !== "Home" && currentUser?.role?.name === "super-admin");
              if (isHidden) return null;

              return (
                <Link
                  to={r.path}
                  key={i}
                  className={`relative px-4 py-2.5 md:py-3 text-[13px] md:text-sm font-medium transition-colors flex-shrink-0 ${pathname === r.path
                    ? "text-primary-900 after:absolute after:bottom-0 after:left-4 after:right-4 after:h-0.5 after:bg-primary-900 after:rounded-full"
                    : "text-slate-500 hover:text-slate-800"
                    }`}
                >
                  {r.name}
                </Link>
              );
            })}
          </div>
        </div>
      )}
    </header>
  );
};
